import { render, staticRenderFns } from "./facial_info_detail.vue?vue&type=template&id=fb2a9c6c"
import script from "./facial_info_detail.vue?vue&type=script&lang=js"
export * from "./facial_info_detail.vue?vue&type=script&lang=js"
import style0 from "./facial_info_detail.vue?vue&type=style&index=0&id=fb2a9c6c&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports